import { gql } from '@apollo/client';

export default gql`
  mutation CancelTravelPassProduct(
    $bookingReference: String!
    $fee: Float!
    $itemRef: String!
    $cancellationReason: String
    $travelPassReference: String
    $skipConfirmation: Boolean
  ) {
    cancelTravelPassProduct(
      bookingReference: $bookingReference
      itemRef: $itemRef
      fee: $fee
      cancellationReason: $cancellationReason
      travelPassReference: $travelPassReference
      skipConfirmation: $skipConfirmation
    ) {
      reference
      paymentsRefundBalance
      travelPassProducts {
        travelDate
        startDate
        endDate
        name
        code
        price
        currency
        itemRef
        type
        passenger {
          id
          firstName
          lastName
        }
        cancelled
        provisional
        canBeCancelled
        canBeRefunded
        productFamilyId
      }
    }
  }
`;
